import clsx from 'clsx';

const ButtonText = ({ children, className }) => {
  return <span className={clsx('inline-block', className)}>{children}</span>;
};

export default ButtonText;
